// components/RepuestosSection.tsx

import { SetStateAction, useMemo, useState } from 'react';
import { Trash2 } from 'lucide-react';


import { IconButton } from '@/presentation/components/common/IconButton/IconButton';
import { useSimple } from '@/presentation/hooks/useSimple';

import { ActionSection } from './ActionSection';
import { CreateDialog } from './CreateActionDialog';
import { DeleteActionDialog } from './DeleteActionDialog';
import { Form } from '@/presentation/components/Forms/Form/Form';
import { useRepuesto } from '@/presentation/hooks/useRepuesto';
import { useAuthContext } from '@/presentation/context';



interface RepuestosSectionProps {
  incidenteId: string;
}

export function RepuestosSection({
  incidenteId,
}: RepuestosSectionProps) {
  const [createOpen, setCreateOpen] =
    useState(false);
const { user } = useAuthContext();
  const [deleteOpen, setDeleteOpen] =
    useState(false);
  const [alertOpen, setAlertOpen] =
    useState(false);
  const [nombre, setNombre] = useState<string | null>(null);
  const [cantidad, setCantidad] = useState<number | null>(null);
  const [selectedId, setSelectedId] =
    useState<number | null>(null);
  const [restante, setRestante] = useState<number | null>(null);

  const { data: tiposRep, reload: loadTiposRep } = useSimple(
    'luc_tipo_repuesto'
  );

  const {
    remove,
  } = useSimple('luc_repuestos');

  const { data: Repuestos, create, reload } = useRepuesto(
    incidenteId

  );


  const options = useMemo(
    () => {
      const seenIds = new Set<string>();

      return tiposRep
        .filter((tipo) => {
          const key = String(tipo.id);
          if (seenIds.has(key)) return false;
          seenIds.add(key);
          return true;
        })
        .map((tipo) => ({
          value: tipo.id,
          label: tipo.nombre,
        }));
    },
    [tiposRep]
  );

  const columns =
    [
      {
        key: 'nombre',
        header: 'Detalle',
      },
      {
        key: 'cantidad',
        header: 'Cantidad'
      },
       {
        key: 'usuario',
        header: 'Usuario'
      },
      {
        key: 'id',
        header: '',
        render: (item: { id: SetStateAction<number | null>; }) => (
          <IconButton
            icon={<Trash2 size={30} />}
            title="Eliminar"
            color="danger"
            onClick={() => {
              setSelectedId(item.id);
              setDeleteOpen(true);
            }}
          />
        ),
      },
    ];

  const handleOpenCreate = async () => {
    if (tiposRep.length === 0) {
      await loadTiposRep();
    }
    console.log(tiposRep);

    setCreateOpen(true);
  };


  const handleCreate = async (
    values: Record<string, unknown>
  ) => {
    const cantidadStock = Number(tiposRep.find((tipo) => tipo.id === Number(values.nombre))?.cantidad ?? 0);
    if (Number(values.cantidad) > cantidadStock) {
      setCantidad(Number(values.cantidad));
      setNombre(String(values.nombre));
      setRestante(Number(values.cantidad) - cantidadStock);
      setAlertOpen(true);
      setCreateOpen(false);
      return;
    }

    await create({
      nombre: String(values.nombre),
      incidente: Number(incidenteId),
      cantidad: Number(values.cantidad),
      fecha: new Date().toISOString(),
      usuario: String(user?.id ?? 0)
    });
    await reload();


    setCreateOpen(false);
  };

  const handleDelete = async () => {
    if (selectedId === null) return;

    await remove(selectedId);
    await reload();

    setDeleteOpen(false);
    setSelectedId(null);
  };
  const handleAlert = async () => {
    if (nombre === null || cantidad === null) return;
    await create({
      
      nombre: String(nombre),
      incidente: Number(incidenteId),
      cantidad: Number(cantidad),
      fecha: new Date().toISOString(),
      usuario: String(user?.id ?? 0)
    });
    await reload();
    setAlertOpen(false);
  }
  return (
    <>
      <ActionSection
        title="Repuestos"
        buttonLabel="Nuevo Repuesto"
        data={Repuestos.map((item) => ({ ...item, fecha: new Date(item.fecha) }))}
        columns={columns}
        emptyMessage="No hay Respuestos cargados"
        onCreate={handleOpenCreate}
      />

      <CreateDialog
        open={createOpen}
        title="Nueva Repuesto"
        onClose={() => setCreateOpen(false)}
      >
        <Form
          fields={[
            {
              name: "nombre",
              type: "select",
              label: "Repuesto",
              options,
            },
            {
              name: "cantidad",
              type: "number",
              label: "Cantidad",
              validation: (value) => {
                if (Number(value) < 1) {
                  return 'Tiene que ser mayor a 0';
                }

                return null;
              },
            },

          ]}
          submitLabel="Agregar"
          onSubmit={handleCreate}
        />
      </CreateDialog>

      <DeleteActionDialog
        open={deleteOpen}
        title="Eliminar Repuesto"
        message="¿Seguro que quiere eliminar el/los repuesto/s?"
        onClose={() => setDeleteOpen(false)}
        onConfirm={handleDelete}
      />
       <DeleteActionDialog
        open={alertOpen}
        title="Agregar Repuesto"
        message={`¿Seguro que quiere Agregar el/los repuesto/s? Se require ${restante} unidades.`}
        onClose={() => setAlertOpen(false)}
        onConfirm={handleAlert}
      />
    </>
  );
}
